import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Brian L.',
  pet: 'Polo the Pomsky',
  quote: "I've tried so many habit trackers, but having my real dog Polo cheer me on makes all the difference. I haven't missed a day of journaling in a month!",
  avatar: '👨🏻',
  petImage: 'https://cdn.magicpatterns.com/uploads/xwayJoBStWpMdEiyffnsue/idle.png'
}, {
  name: 'James T.',
  pet: 'Max the Golden',
  quote: "The breathing exercises are incredible. Seeing digital Max breathe along with me instantly calms my anxiety. It's the sweetest app on my phone.",
  avatar: '👨🏽',
  petImage: 'https://cdn.magicpatterns.com/uploads/ehze6eRdooopAgjJvUg4C5/idle.png'
}, {
  name: 'Sarah M.',
  pet: 'Luigi the Beagle',
  quote: 'Pawchi turned self-care from a chore into a joy. Checking off my water intake to give Luigi a digital treat is surprisingly motivating!',
  avatar: '👱🏼‍♀️',
  petImage: 'https://cdn.magicpatterns.com/uploads/bKuXUL7RUXEoK5eQMe8PC7/idle.png'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-white" data-id="element-150" data-mp="m2yceiy2y3rk">
      <div className="max-w-7xl mx-auto px-6" data-id="element-151" data-mp="78tt4xpd4fvs">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-152" data-mp="7a4wwxit5nmw">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black text-warmBrown mb-6" data-id="element-153" data-mp="c7myg2uhx0kv">
            Loved by humans.
            <br data-id="element-154" data-mp="v4xulektzdw3" />
            <span className="text-coral" data-id="element-155" data-mp="v4enkswpy9wu">Approved by pets.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-156" data-mp="1iuih27g70ta4">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-cream rounded-3xl p-8 shadow-sm relative flex flex-col h-full" data-id="element-157" data-mp="1nnla8eh260ps" data-mpi={index}>
              <div className="flex gap-1 mb-6" data-id="element-158" data-mp="1ekzipqjrhxv8">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} size={18} className="text-peach" fill="currentColor" data-id="element-159" data-mp="19qlfj1yuymg0" />)}
              </div>

              <p className="text-warmBrown/80 text-lg mb-8 leading-relaxed italic" data-id="element-160" data-mp="vt6ojssyi6lx">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-161" data-mp="qu2e6yuaq2u0">
                <div className="relative" data-id="element-162" data-mp="32hp50zmlw7mn">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-2xl shadow-sm" data-id="element-163" data-mp="32gnucw9i5n5g">
                    {testimonial.avatar}
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-coral rounded-full flex items-center justify-center text-xs border-2 border-cream overflow-hidden" data-id="element-164" data-mp="3cflelmzwauin">
                    {testimonial.petImage ? <img src={testimonial.petImage} alt={testimonial.pet} className="w-full h-full object-cover bg-white" data-id="element-165" data-mp="2jobi9ht1r7i4" /> : testimonial.petEmoji}
                  </div>
                </div>
                <div data-id="element-166" data-mp="210pxzvhouizg">
                  <h4 className="font-bold text-warmBrown" data-id="element-167" data-mp="20zexq5ngbtd3">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-warmBrown/60" data-id="element-168" data-mp="24zfalluwjwi1">
                    with {testimonial.pet}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}